import { APP_INITIALIZER, enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app/app.component';
import { AppRoutes } from './app/app.routes';
import { environment } from './environments/environment';

import { HttpRequestInterceptor } from './app/shared/_helpers/http-request-interceptor';
import { BuildDetailsService } from './app/shared/services/build-details.service';
import { LangService } from './app/shared/services/lang.service';

import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getRoPaginatorIntl } from './app/shared/components/tables/regular-table/ro-paginator-intl';

import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
import { MatDialogModule } from '@angular/material/dialog';

registerLocaleData(localeRo);

if (environment.production) {
  enableProdMode();
}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function fetchBuildDetails(buildDetailsService: BuildDetailsService) {
  return () => buildDetailsService.getBuildDetails();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      HttpClientModule,
      MatDialogModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient]
        }
      })
    ),

    provideRouter(AppRoutes, withHashLocation()),
    provideAnimations(),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },

    {
      provide: APP_INITIALIZER,
      useFactory: fetchBuildDetails,
      deps: [BuildDetailsService],
      multi: true
    },

    { provide: LOCALE_ID, useValue: 'ro-RO' },
    { provide: MAT_DATE_LOCALE, useValue: 'ro-RO' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },

    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MatPaginatorIntl, useValue: getRoPaginatorIntl() },

    LangService
  ]
});